"use client";

import { useId } from "react";

import cn from "classnames";

import { ChevronDownIcon } from "../icons/chevronDown.icon";

export const Select = ({
  id,
  name = "select",
  children,
  onChange,
  loading,
  className,
  containerClassName,
  ...rest
}: SelectProps) => {
  const selectId = id || useId();
  return (
    <div
      className={cn("relative w-fit max-w-full min-w-0", containerClassName)}>
      <label htmlFor={selectId} className="sr-only">
        Select an option
      </label>
      {loading ? (
        <Select {...rest} className={className} onChange={() => {}}>
          {children}
        </Select>
      ) : (
        <select
          className={cn(
            "border-greyscale-strength text-greyscale-body h-11.25 w-fit max-w-full min-w-0 cursor-pointer appearance-none rounded-full border bg-white py-2.5 pr-8 pl-4 text-ellipsis transition-colors focus:ring-3 focus:ring-black/10 focus:outline-none",
            className,
          )}
          name={name}
          id={selectId}
          autoComplete="off"
          onChange={onChange}
          {...rest}>
          {children}
        </select>
      )}

      <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
        <ChevronDownIcon width={24} height={24} />
      </div>
    </div>
  );
};

export type SelectProps = {
  id?: string;
  name?: string;
  children: React.ReactNode;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  className?: string;
  containerClassName?: string;
  loading?: boolean;
} & React.SelectHTMLAttributes<HTMLSelectElement>;
